import { Card, Badge, Spinner } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const roleColor   = r => ({ admin: 'danger', editor: 'primary', viewer: 'secondary' }[r] ?? 'secondary');
const statusColor = s => ({ active: 'success', pending: 'warning', suspended: 'danger' }[s] ?? 'secondary');

function RecentUsersCard({ loading, recentUsers }) {
  return (
    <Card className="dashboard-card border-0 h-100">
      <Card.Header className="bg-white border-bottom-0 pt-3 pb-2 d-flex justify-content-between align-items-center">
        <h6 className="mb-0 fw-semibold">
          <i className="bi bi-clock-history me-2 text-primary"></i>Recent Users
        </h6>
        <Link to="/admin/users" className="btn btn-sm btn-outline-primary">
          Manage
        </Link>
      </Card.Header>
      <Card.Body className="p-0">
        {loading ? (
          <div className="text-center py-4"><Spinner animation="border" size="sm" /></div>
        ) : recentUsers.length === 0 ? (
          <p className="text-muted text-center py-4 mb-0 small">No users found.</p>
        ) : (
          <div>
            {recentUsers.map((user, i) => (
              <div key={i} className="d-flex align-items-center px-3 py-2 border-bottom">
                <div className="flex-grow-1 min-width-0">
                  <div className="small fw-semibold text-truncate">{user.name || '—'}</div>
                  <div className="small text-muted text-truncate">{user.email}</div>
                </div>
                <div className="ms-2 d-flex flex-column align-items-end gap-1">
                  <Badge bg={roleColor(user.access_type)} className="small">
                    {user.access_type || 'unset'}
                  </Badge>
                  <Badge bg={statusColor(user.status)} className="small">
                    {user.status}
                  </Badge>
                </div>
              </div>
            ))}
          </div>
        )}
      </Card.Body>
    </Card>
  );
}

export default RecentUsersCard;
